<template>
  <AppTooltip
    :location="location"
    content-class="AppInfoTooltip"
    v-bind="$attrs"
    :max-width="435"
  >
    <template #activator="{ props }">
      <v-icon
        v-bind="props"
        class="mx-1 clickable"
        :class="{ 'text-tertiary': isActive }"
        :size="iconSize"
        @mouseenter="isActive = true"
        @mouseleave="isActive = false"
      >
        {{ isActive ? `fas ${icon}` : `far ${icon}` }}
      </v-icon>
    </template>
    <span>
      <!-- @slot for tooltip content -->
      <slot></slot>
    </span>
  </AppTooltip>
</template>

<script>
import AppTooltip from '@/common/AppTooltip.vue'
/**
 * @displayName AppInfoTooltip
 */
/**
 * Default Info tooltip.
 * Uses the AppTooltip component.
 */
export default {
  name: 'AppInfoTooltip',
  components: { AppTooltip },
  inheritAttrs: false,
  props: {
    /**
     * Icon size
     */
    iconSize: {
      type: [String, Number],
      default: 16,
    },
    location: {
      type: String,
      validator: (value) => {
        return ['right', 'top', 'bottom'].includes(value)
      },
      default: 'right',
    },
    icon: {
      type: String,
      default: 'fa-circle-info',
    },
  },
  data () {
    return {
      isActive: false,
    }
  },
}
</script>

<style lang="scss">
.AppInfoTooltip {
  opacity: 1 !important;
  line-height: 16px;
  padding: 15px 20px;
}
</style>
